import React, {useState} from "react";
import styled from "styled-components";
import {Attach} from '@alfalab/core-components/attach';
import {Typography} from '@alfalab/core-components/typography';
import AlphaIcon from 'arui-feather/icon/brand/bank-2449';
import {IntlPhoneInput} from '@alfalab/core-components/intl-phone-input';
import FormField from 'arui-feather/form-field';
import {Input} from '@alfalab/core-components/input';
import {Button} from '@alfalab/core-components/button';
import Label from 'arui-feather/label';
import * as Yup from "yup"
import {Form} from "arui-feather/form";
import {Formik} from "formik";
import Success from "../Events/Success/Success";
import {FileUploadItem} from "@alfalab/core-components/file-upload-item";

type Props = {
    purchaseId: string;
    subjectPurchase: string;
    personalNumberPurchase: string;
    loadFormData: (data: object, purchaseId: string) => Promise<any>
}

export type  Counterpart = {
    name: string,
    unp: string,
    fio: string,
    email: string,
    phone: string,
}

export type  MyFormValues = {
    purchaseId: string,
    subjectPurchase: string,
    counterpart: Counterpart,
    files: File[]
}

const parseURL = () => {
    let params = decodeURIComponent(window.location.hash.split("?").pop() || "").split("&");
    let paramsArr: any,
        value: string | undefined,
        key: string | undefined;
    paramsArr = {};
    for (let i: number = 0; i < params.length; i++) {
        key = params[i].split("=").shift();
        value = params[i].split("=").pop();
        if (key) paramsArr[key] = value;
    }
    return paramsArr;
};

const Forma: React.FC<Props> = (props: Props) => {

    let paramsURL = parseURL();
    const [isSuccess, setIsSuccess] = useState(false);
    const [data, setData] = useState<MyFormValues>({
        purchaseId: "",
        subjectPurchase: "",
        counterpart: {
            name: "",
            unp: "",
            fio: "",
            email: "",
            phone: "",
        },
        files: []
    });

    const initialValues: MyFormValues = {
        purchaseId: `${props.purchaseId}`,
        subjectPurchase: `${props.subjectPurchase}`,
        counterpart: {
            name: paramsURL.name || "",
            unp: paramsURL.UNP || "",
            fio: paramsURL.FIO || "",
            email: paramsURL.email || "",
            phone: paramsURL.phone || "+375",
        },
        files: [],
    };

    return (
        isSuccess ? <Success data={data}/> :
            <Container>
                <Formik
                    initialValues={initialValues}
                    validationSchema={ValidationData}
                    onSubmit={values => {
                        props.loadFormData(values, props.purchaseId);
                        setData(values);
                        setIsSuccess(true)
                    }}
                >
                    {({
                          isValid,
                          dirty,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                      }) => {
                        return (
                            <Form onSubmit={handleSubmit}>
                                <FlexDiv>
                                    <AlphaIcon className="alfa" colored={true}/>
                                    <Typography.Title weight="bold" tag="h1" className="title">
                                        Альфа-Тендеры: Сервис подачи конкурсных предложений ЗАО «Альфа-Банк»
                                    </Typography.Title>
                                </FlexDiv>
                                <Typography.Text>Пожалуйста, сверьте номер и предмет закупки с указанными в приглашении,
                                    затем внимательно заполните данные Вашей компании и приложите документы конкурсного
                                    предложения.</Typography.Text>

                                <label htmlFor="object">Номер закупки:</label>
                                <div>
                                    <StyledLabel id="object">{props.personalNumberPurchase}</StyledLabel>
                                </div>
                                <label htmlFor="object">Предмет закупки:</label>
                                <div>
                                    <StyledLabel id="object">{props.subjectPurchase}</StyledLabel>
                                </div>
                                <label htmlFor="nameAgent"> Наименование лица (компании, ИП) согласно регистрационным
                                    документам:</label>
                                <div>
                                    <FormField>
                                        <Input block onChange={handleChange}
                                               error={errors.counterpart?.name && touched.counterpart?.name && errors.counterpart?.name}
                                               onBlur={handleBlur}
                                               value={values.counterpart.name}
                                               id="nameAgent"
                                               name="counterpart.name"
                                               placeholder='Введите оф. название своей организации (например, ООО «Контрагент»)'
                                        />
                                    </FormField>
                                </div>
                                <label htmlFor="unpAgent">УНП/рег. номер контрагента:</label>
                                <div>
                                    <FormField>
                                        <Input block
                                               error={errors.counterpart?.unp && touched.counterpart?.unp && errors.counterpart?.unp}
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.counterpart.unp}
                                               id="unpAgent"
                                               name="counterpart.unp"
                                               placeholder='Введите УНП (или др. рег. номер) своей организации'
                                        />
                                    </FormField>
                                </div>
                                <div>
                                    <Typography.Text>Контактные данные лица, ответственного за направление предложения в
                                        адрес
                                        Банка:</Typography.Text>
                                </div>

                                <label htmlFor="fio">ФИО контактного лица:</label>
                                <div>
                                    <FormField>
                                        <Input block
                                               error={errors.counterpart?.fio && touched.counterpart?.fio && errors.counterpart?.fio}
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.counterpart.fio}
                                               className="inputField" id="fio" name="counterpart.fio"
                                               placeholder='Введите своё ФИО (полностью)'
                                        />
                                    </FormField>

                                </div>
                                <label htmlFor="email"> E-mail контактного лица:</label>
                                <div>
                                    <FormField>
                                        <Input className="shortInput"
                                               error={errors.counterpart?.email && touched.counterpart?.email && errors.counterpart?.email}
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.counterpart.email}
                                               type="email" id="email" name="counterpart.email"
                                               placeholder='Введите свой e-mail'
                                        />
                                    </FormField>
                                </div>
                                <label htmlFor="telephone"> Телефон контактного лица:</label>
                                <div>
                                    <FormField>
                                        <IntlPhoneInput
                                            defaultCountryIso2="by"
                                            error={errors.counterpart?.phone && touched.counterpart?.phone && errors.counterpart?.phone}
                                            onChange={(e: any) => setFieldValue('counterpart.phone', e)}
                                            onBlur={handleBlur}
                                            value={values.counterpart.phone}
                                            className="shortInput" name="counterpart.phone"
                                        />
                                    </FormField>
                                </div>
                                <label htmlFor="file-input">Приложите файлы (документы) конкурсного предложения:</label>
                                <Typography.Text view='primary-small' >Можно загружать файлы с расширениями .pdf, .jpeg, .bmp, .png, .gif, .xls, .xlsx, .doc,
                                    .docx, .ppt, .pptx, .jpg, .tif<br/> Максимальный размер загружаемых файлов - 100 МБ.</Typography.Text>
                                <Attach name="files"
                                        onBlur={handleBlur}
                                    //@ts-ignore
                                        onChange={(event: any) => {
                                            setFieldValue('files', [...values.files, ...event.target.files]);
                                        }}
                                        onClear={() => setFieldValue('files', [])}
                                        value={values.files}
                                        accept='.pdf, .jpeg, .bmp, .png, .gif, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .jpg, .tif'
                                        buttonContent='Выберите файл'
                                        size='s' multiple
                                />
                                {values.files.map((file, i) => <FileUploadItem
                                    onDelete={() => {
                                    setFieldValue('files', [...values.files.filter((el, fileId) => fileId !== i)]);
                                }} showDelete name={file.name} key={i} size={file.size}/>)}
                                <ErrorMessage>{errors.files && touched.files && errors.files} </ErrorMessage>
                                <div>
                                    <StyledButton aria-disabled={!(isValid && dirty)} view="primary"
                                                  type='submit'>Отправить</StyledButton>
                                </div>
                            </Form>
                        )
                    }
                    }
                </Formik>
            </Container>
    );
};

const phoneRegExp = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/;

const ValidationData: any = Yup.object().shape({
    counterpart: Yup.object({
        name: Yup.string()
            .min(2, 'Слишком короткое значение')
            .max(50, 'Слишком длинное значение')
            .required('Обязательное поле'),
        unp: Yup.string()
            .required('Обязательное поле'),
        fio: Yup.string()
            .min(6, 'Слишком короткое значение')
            .max(80, 'Слишком длинное значение')
            .required('Обязательное поле'),
        email: Yup.string().email('Неверный формат e-mail').required('Обязательное поле'),
        phone: Yup.string().matches(phoneRegExp, 'Номер телефона указан неверно')
            .required('Обязательное поле'),
    }),
    files: Yup.array().min(1, "Необходимо прикрепить хотя бы один файл").nullable()
});

const FlexDiv = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
`;

const Container = styled.div`
    width: 950px;
    padding: 40px 50px 40px;
    box-shadow: 0 0 5px 0 rgba(0,0,0,.2);
    box-sizing: border-box;
    margin: 40px auto 20px;
    background: #fff;
    border-radius: 3.01px;
    display: flex;
    flex-direction: column;
    align-items: center; 
    
    @media screen and (max-width: 949px){
        width: 100%;
        border-radius: 0;
        padding: 20px 30px 20px;
    }
    
    Form {
        display: flex;
        flex-direction: column;
        width: 90%;
        padding: 5px;
    
        > *  { 
        margin: 5px;
        }
            
        label{
        color: #6b778c;
        font-size: 12px;
        font-weight: 600;
        }
    }
`;
const StyledButton = styled(Button)`
    margin-top: 20px;
`;

const StyledLabel = styled(Label)`
    font-weight: bold;
`;
const ErrorMessage = styled.p`
   color: red;
`;

export default Forma;